function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2px",
  d: "M11,6.114V17.669M11,6.114A7.292,7.292,0,0,0,7,5,7.292,7.292,0,0,0,3,6.114V17.669a7.292,7.292,0,0,1,4-1.114,7.292,7.292,0,0,1,4,1.114M11,6.114A7.292,7.292,0,0,1,15,5a7.29,7.29,0,0,1,4,1.114V17.669a7.29,7.29,0,0,0-4-1.114,7.292,7.292,0,0,0-4,1.114",
  transform: "translate(0 1)"
}));

var SvgITextbookCreator = function SvgITextbookCreator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15.056,
    viewBox: "0 0 18 15.056",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgITextbookCreator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_textbook_creator.23b5f73d.svg";
export { ForwardRef as ReactComponent };